module.exports = __webpack_public_path__ + "img/对号.407e8c64.svg";